export default "__VITE_ASSET__C_7Xvg5g__"